import { useMutation } from 'react-query';
import { endOfDay } from 'date-fns';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
    customerId: string;
    accountId: string;
    reportData: any;
}

export const useGenerateProfitAndLossReport = ({ reportData, customerId, accountId }: IProps) => useMutation(
  'generateProfitAndLossReport',
  async () => {
    if (reportData?.period?.endDate) {
      reportData = { ...reportData, period: { ...reportData.period, endDate: endOfDay(new Date(reportData.period.endDate)) } };
    }
    const res = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/${accountId}/reports/profitAndLoss`, reportData, {
      responseType: 'blob',
    });
    const contentDisposition = res.headers['content-disposition'];
    const filename = contentDisposition.split(';')[1];
    const firstSpliceIdx = filename.indexOf('"');
    const parsedName = filename.substring(firstSpliceIdx + 1, filename.length - 1);
    const IframeUrl = URL.createObjectURL(res.data);
    return { IframeUrl, parsedName };
  },
);
